<template>
    <a
        class="flex items-center justify-center font-medium text-sm"
        :href="phoneLink"
    >
        <span class="sm:hidden text-gray-500 hover:text-gray-700"
            >Need Help?</span
        >
        <PhoneIcon class="h-5 w-5 mx-4 text-gray-400 hover:text-gray-500" />
        <span
            class="pr-4 sm:pr-6 lg:pr-8 hidden sm:inline text-gray-500 hover:text-gray-700"
            >{{ phone }}</span
        >
    </a>
</template>

<script setup lang="ts">
import { useGooglePhoneConversion } from "../../functions/useGooglePhoneConversion";
import { PhoneIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    headquarters?: any;
}>();

const { phone, phoneLink, swapWithForwardingNumber } =
    useGooglePhoneConversion();

phone.value = props.headquarters.phone;
phoneLink.value = props.headquarters.phoneLink;
swapWithForwardingNumber(props.headquarters.phone);
</script>
